export default __webpack_public_path__ + "static/media/pexels-pixabay-161688.dc506c2e.jpg";